import updateCart from '~/firebase/update/updateCart';
import useCartId from '~/hooks/useCartId';
import { PLATFORM_ID } from '~/globalVariables';
import { PaymentType } from '~/types/common';
import { useSetRecoilState } from 'recoil';
import { useParams } from 'react-router-dom';
import paymentTypeAtom from '~/recoil/atom/paymentType';

export default function usePaymentType(paymentType: PaymentType) {
  const { cartId } = useCartId();
  const { enterpriseGroupBuyId = '' } = useParams();
  const setPaymentType = useSetRecoilState(paymentTypeAtom);

  const handleChangePaymentType = async (type: PaymentType) => {
    if (!cartId) {
      return;
    }

    try {
      await updateCart(PLATFORM_ID, cartId, {
        paymentType: type,
      });
      if (!!enterpriseGroupBuyId) setPaymentType(type);
    } catch (err) {
      console.error('update payment type error');
    }
  };

  return {
    paymentType,
    handleChangePaymentType,
  };
}
